/* ============================================================
   KeyPets theme.js — v17 experience wired to real Shopify data.
   Data arrives via window.KP (layout/theme.liquid).
   ============================================================ */
(function(){
'use strict';
var KP = window.KP || {};
var $ = function(s){ return document.querySelector(s); };
var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
function escHtml(t){
  return String(t == null ? '' : t)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}

/* ===== MONEY ===== */
function money(cents){
  if (typeof curNow === 'string' && curNow !== BASE_CUR) return curFmt(cents);
  var amt = (cents/100).toFixed(2);
  var fmt = KP.moneyFmt || '${{amount}}';
  return fmt
    .replace(/\{\{\s*amount\s*\}\}/g, Number(amt).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}))
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents/100).toLocaleString('en-US'))
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amt.replace('.',','))
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(cents/100).toLocaleString('de-DE'))
    .replace(/<[^>]+>/g,'');
}

/* ===== GAMES DATA ===== */
var GAMES = (KP.games || []).filter(Boolean).map(function(g){
  g.subs = (g.subsRaw || '').split(',').map(function(p){
    var kv = p.split('|');
    return kv.length === 2 ? { id: kv[0].trim(), label: kv[1].trim() } : null;
  }).filter(Boolean);
  g.peek = (g.peek || []).filter(function(u){ return u && u.length > 4; });
  if (g.peek.length < 2) g.peek = null;
  return g;
});
function gameById(id){
  for (var i=0;i<GAMES.length;i++){
    if (GAMES[i].id === id || GAMES[i].legacy === id) return GAMES[i];
  }
  return null;
}

/* ===== TIERS + FALLBACK META (original KeyPets inventory) ===== */
var TIERS = {
  sup:['SUPER','#8C6BFF','rp--super'], myt:['MYTHIC','#EF3838','rp--myt'],
  leg:['LEGENDARY','#FFD23F','rp--leg'], epi:['EPIC','#B44BF0','rp--epi'],
  rar:['RARE','#3D9BE8','rp--rar'], unc:['UNCOMMON','#5CD97A','rp--unc'],
  com:['COMMON','#9AA5B8','rp--com'], sec:['SECRET','#E8E4F5','rp--sec'],
  og:['OG','#E84DC8','rp--og'], ger:['GEARS','#8FA2D8','rp--ger'],
  bun:['BUNDLE','#F5B62E','rp--bun']
};
/* name (lowercase) -> [tier, sub] — used when a product has no tags/collection category yet.
   Lookups also try the name with a trailing " seed(s)" stripped or added, so one entry covers both title styles. */
var KP_META = {"sun bloom seed":["sup","seed"],"dragons breath seed":["sup","seed"],"dragon's breath seed":["sup","seed"],"hypno bloom seed":["sup","seed"],"moon bloom seed":["sup","seed"],"star fruit seed":["sup","seed"],"amber cranberry seed":["sup","seed"],"amber cranberry":["sup","seed"],"ghost pepper seed":["myt","seed"],"venus fly trap seed":["myt","seed"],"venom spitter seed":["myt","seed"],"mega seed":["myt","seed"],"rainbow seed":["myt","seed"],"rainbow seeds":["myt","seed"],"romanesco seed":["myt","seed"],"romanesco":["myt","seed"],"poison apple seed":["myt","seed"],"poison apple":["myt","seed"],"pomegranate seed":["myt","seed"],"pomegranate":["myt","seed"],"maple venus fly trap":["myt","seed"],"maple pomegranate":["myt","seed"],"maple poison apple":["myt","seed"],"maple venom spitter":["myt","seed"],"conifer cone":["myt","seed"],"conifer cone seed":["myt","seed"],"conifer cone sapling":["myt","seed"],"briar rose":["myt","seed"],"briar rose seed":["myt","seed"],"ghost pepper":["myt","seed"],"venom spitter":["myt","seed"],"venus fly trap":["myt","seed"],"rocket pop seed":["leg","seed"],"rocket pop":["leg","seed"],"gold seed":["leg","seed"],"eclipse bloom":["sec","seed"],"eclipse bloom seed":["sec","seed"],"raccoon":["sup","pet"],"black dragon":["sup","pet"],"ice serpent":["sup","pet"],"rainbow black dragon":["sup","pet"],"rainbow ice serpent":["sup","pet"],"rainbow raccoon":["sup","pet"],"rb ice serpent":["sup","pet"],"firefly":["myt","pet"],"bald eagle":["myt","pet"],"bear":["myt","pet"],"unicorn":["myt","pet"],"golden dragonfly":["myt","pet"],"rainbow firefly":["myt","pet"],"rainbow bald eagle":["myt","pet"],"rainbow bear":["myt","pet"],"rainbow unicorn":["myt","pet"],"rainbow golden dragonfly":["myt","pet"],"monkey":["myt","pet"],"robin":["leg","pet"],"bee":["leg","pet"],"rainbow robin":["leg","pet"],"rainbow bee":["leg","pet"],"bunny":["com","pet"],"frog":["com","pet"],"rainbow bunny":["com","pet"],"deer":["rar","pet"],"turtle":["rar","pet"],"super watering can":["ger","gear"],"super sprinkler":["ger","gear"],"20x trowels":["ger","gear"],"growing kit bundle":["ger","bun"],"eclipse bundle":["bun","bun"],"meowl":["og","rot"],"skibi":["og","rot"],"dragon cannelloni":["sec","rot"],"antonio":["sec","rot"],"dragon aquanini":["sec","rot"],"dragon gingerini":["sec","rot"],"ginger gerat":["sec","rot"],"la supreme combinasion":["sec","rot"],"digi narwhal":["sec","rot"],"jelly moby":["sec","rot"],"random 1b/s+ secret":["sec","rot"],"la secret combinasion":["sec","rot"],"hydra dragon":["sec","rot"],"ketupat bros":["sec","rot"],"la casa boo":["sec","rot"],"gym bros":["sec","rot"],"rosey and teddy":["sec","rot"],"cooki & milki":["sec","rot"],"coco & mango":["sec","rot"],"celestial pegasus":["sec","rot"],"cerberus":["sec","rot"],"fragrama & chocrama":["sec","rot"],"cash or card":["sec","rot"],"capitano moby":["sec","rot"],"popcuru and fizzuru":["sec","rot"],"burguro & fryuro":["sec","rot"],"garama & madundung":["sec","rot"],"esok sekolah":["sec","rot"],"elefanto frigo":["sec","rot"],"eviledon":["sec","rot"],"foxini lanternini":["sec","rot"],"globa steppa":["sec","rot"],"ketchuru & musturu":["sec","rot"],"griffin":["sec","rot"],"ketupat kepat":["sec","rot"],"la ginger sekolah":["sec","rot"],"spooky & pumpky":["sec","rot"],"demon's head":["ger","gear"],"radioactive airstrike":["ger","gear"],"santa sleigh":["ger","gear"],"cupid's wings":["ger","gear"],"witch broom":["ger","gear"],"wave rider":["ger","gear"],"3x meta bundle":["bun","bun"],"plum":["leg","seed"],"maple sunflower":["leg","seed"],"atlantic giant pumpkin":["leg","seed"],"maple dragon fruit":["leg","seed"],"maple acorn":["leg","seed"],"maple cherry":["leg","seed"],"maple mushroom":["epi","seed"],"maple green bean":["epi","seed"],"maple banana":["epi","seed"],"maple grape":["epi","seed"],"maple coconut":["epi","seed"],"maple mango":["epi","seed"],"maple bamboo":["rar","seed"],"maple corn":["rar","seed"],"maple cactus":["rar","seed"],"maple pineapple":["rar","seed"],"maple tulip":["unc","seed"],"maple tomato":["unc","seed"],"maple apple":["unc","seed"],"maple carrot":["com","seed"],"maple strawberry":["com","seed"],"maple blueberry":["com","seed"],"sun bloom":["sup","seed"],"moon bloom":["sup","seed"],"hypno bloom":["sup","seed"],"star fruit":["sup","seed"],"dragons breath":["sup","seed"],"dragon's breath":["sup","seed"],"dog":["unc","pet"],"hedgehog":["rar","pet"],"turkey":["rar","pet"],"squirrel":["leg","pet"],"swan":["leg","pet"],"jandel monkey":["myt","pet"],"fox":["myt","pet"],"wolf":["myt","pet"],"shadow dragon":["sup","pet"],"rainbow shadow dragon":["sup","pet"],"rb shadow dragon":["sup","pet"],"rainbow fox":["myt","pet"],"rainbow wolf":["myt","pet"],"rainbow jandel monkey":["myt","pet"],"rainbow squirrel":["leg","pet"],"rainbow swan":["leg","pet"],"rainbow hedgehog":["rar","pet"],"rainbow turkey":["rar","pet"],"rainbow dog":["unc","pet"],"strawberry elephant":["og","rot"],"john pork":["og","rot"],"maple rainbow seed":["myt","seed"],"maple rainbow seeds":["myt","seed"],"maple rainbow bundle":["myt","seed"],"maple venus flytrap":["myt","seed"],"venus flytrap":["myt","seed"],"kitsune":["sup","pet"],"red panda":["sup","pet"],"mega fox":["myt","pet"],"common egg":["com","pet"],"uncommon egg":["unc","pet"],"rare egg":["rar","pet"],"epic egg":["epi","pet"],"legendary egg":["leg","pet"],"mythic egg":["myt","pet"],"super egg":["sup","pet"],"harvest egg":["sup","pet"],"exclusive harvest egg":["sup","pet"],"wolf pack":["myt","pet"],"fox pack":["myt","pet"],"swan pack":["leg","pet"],"5x swan pack":["leg","pet"]};
/* names boosted to the front of the Featured order (tag a product `boost` for the same effect) */
var KP_BOOST = { "amber cranberry": 1, "maple rainbow": 1, "maple rainbow seeds": 1, "maple rainbow bundle": 1, "atlantic giant pumpkin": 1, "poison apple": 1 };
/* names sunk to the bottom of Featured — slow/older stock (tag `lower` for the same effect) */
var KP_SINK = { "gold seed": 1, "gold seeds": 1, "venom spitter": 1 };

function inferSub(name, g){
  if (/bundle|\bkit\b|\bpacks?\b/.test(name)) return 'bun';
  if (/watering can|sprinkler|trowel|\bgears?\b/.test(name)) return 'gear';
  if (/\bseeds?\b|\bsapling\b/.test(name)) return 'seed';
  if (/\beggs?\b/.test(name)) return 'pet';
  if (!g || !g.subs || !g.subs.length) return '';
  /* Unknown item → file it under the game's first (default) tab so it stays
     visible; tags or a "… Seeds/Pets/Gears" collection place it precisely. */
  return g.subs[0].id;
}
function metaFor(key){
  return KP_META[key]
    || KP_META[key.replace(/\s+seeds?\s*$/, '')]
    || KP_META[key + ' seed']
    || KP_META[key.replace(/^(?:mega|big|giant)\s+/, '')]; /* Mega/Big pet variants share the base tier */
}
function enhanceCards(root, gid){
  var g = gid ? gameById(gid) : null;
  var cards = root.querySelectorAll('.card');
  for (var i=0;i<cards.length;i++){
    var c = cards[i];
    if (c.dataset.kpEnh) continue;
    c.dataset.kpEnh = '1';
    var key = (c.dataset.name || '').replace(/[\u2019\u2018]/g, "'");
    var meta = metaFor(key);
    if (!c.dataset.boost && (KP_BOOST[key] || KP_BOOST[key.replace(/\s+seeds?\s*$/, '')])) c.dataset.boost = '1';
    if (!c.dataset.sink && (KP_SINK[key] || KP_SINK[key.replace(/\s+seeds?\s*$/, '')])) c.dataset.sink = '1';
    if (!c.dataset.sub){
      if (meta && meta[1]) c.dataset.sub = meta[1];
      else c.dataset.sub = inferSub(key, g);
    }
    var tier = c.dataset.tier || '';
    if (!tier){
      if (meta && meta[0]) tier = meta[0];
      else if (c.dataset.sub === 'gear') tier = 'ger';
      else if (c.dataset.sub === 'bun') tier = 'bun';
      else if (c.dataset.sub === 'rot') tier = 'sec';
    }
    if (tier && TIERS[tier] && !c.querySelector('.rp')){
      var t = TIERS[tier];
      c.dataset.tier = tier;
      c.style.setProperty('--tier', t[1]);
      var shot = c.querySelector('.card__shot');
      if (shot){
        var span = document.createElement('span');
        span.className = 'rp ' + t[2];
        span.textContent = t[0];
        shot.appendChild(span);
      }
    } else if (tier) { c.dataset.tier = tier; if (TIERS[tier]) c.style.setProperty('--tier', TIERS[tier][1]); }
  }
}

/* ===== VIEWING NOW PILL =====
   Deterministic 40–250 count derived from the clock's current 10-second
   window: it drifts to a nearby number every 10s (never jumping more than
   ~±16, well under 30), wandering up and down across the whole range over
   the day like a real audience. Because it's a pure function of the clock,
   a refresh — or any other visitor — sees the exact same number inside a
   window, so the counter reads as stable instead of random. */
function vnHash(x){
  x = (x ^ 61) ^ (x >>> 16);
  x = (x + (x << 3)) | 0;
  x = x ^ (x >>> 4);
  x = Math.imul(x, 0x27d4eb2d);
  x = x ^ (x >>> 15);
  return x >>> 0;
}
function viewersNow(){
  var slot = Math.floor(Date.now() / 10000);
  var v = 145
    + 60 * Math.sin(slot * 0.00085 + 1.7)   /* ~20h tide */
    + 25 * Math.sin(slot * 0.011 + 4.2)     /* ~95min swell */
    + 12 * Math.sin(slot * 0.13 + 0.8)      /* ~8min ripple */
    + ((vnHash(slot) % 15) - 7);            /* per-window jitter ±7 */
  return Math.max(40, Math.min(250, Math.round(v)));
}
function paintViewers(force){
  var lc = $('#liveCount');
  if (!lc || lc.dataset.soon === '1') return;
  var n = String(viewersNow());
  if (force || lc.dataset.v !== n){
    var settled = lc.dataset.v !== undefined && !force; /* only tick on organic drift */
    lc.dataset.v = n;
    lc.textContent = n + ' Viewing Now';
    if (settled && !RM){
      lc.classList.remove('is-tick'); void lc.offsetWidth; lc.classList.add('is-tick');
    }
  }
}
if ($('#liveCount')){
  paintViewers(false);
  setInterval(function(){ paintViewers(false); }, 1000);
}

/* ===== STATE ===== */
var firstLive = null, i;
for (i=0;i<GAMES.length;i++){ if (!GAMES[i].soon){ firstLive = GAMES[i]; break; } }
if (!firstLive && GAMES.length) firstLive = GAMES[0];
var colMain = document.querySelector('[data-kp-collection]');
var IS_HOME = !!$('#viewHome');
var SHOW_STEP = 10;
var state = {
  game: colMain ? colMain.dataset.gameId : (firstLive ? firstLive.id : null),
  sub: null, sort: 'featured', q: '', shown: 10
};
var swapDir = 0; /* set by banner swipes/dots so render() glides instead of popping */
var RENDER_LIST = [];

/* ===== CARD TEMPLATES ===== */
var TPL = {};
document.querySelectorAll('template[data-game-tpl]').forEach(function(t){
  enhanceCards(t.content, t.dataset.gameTpl);
  TPL[t.dataset.gameTpl] = t.content;
});
var grid = $('#grid');
if (grid && grid.hasAttribute('data-server-cards')){
  enhanceCards(grid, state.game);
  var frag = document.createDocumentFragment();
  while (grid.firstElementChild) frag.appendChild(grid.firstElementChild);
  TPL[state.game] = frag;
}

/* ===== TILES / DROPDOWN / SHEET ===== */
function tileHTML(g, compact){
  var soonAttr = g.soon ? ' data-soon' : '';
  if (compact){
    return '<button class="gcard" data-game="'+g.id+'"'+soonAttr+'>'
      +'<img src="'+g.art+'" alt="" width="56" height="56" loading="lazy">'
      +'<span><b>'+escHtml(g.name)+'</b><small>'+escHtml(g.tag)+'</small>'
      +(g.soon ? '' : '<span class="live">● LIVE</span>')+'</span>'
      +(g.soon ? '<span class="ribbon">SOON</span>' : '')
      +'</button>';
  }
  var peek = g.peek ? '<span class="peek" aria-hidden="true"><img src="'+g.peek[0]+'" alt=""><img src="'+g.peek[1]+'" alt=""></span>' : '';
  return '<button class="tile" role="tab" style="--t:'+g.tint+'" data-game="'+g.id+'"'+soonAttr+' aria-selected="'+(g.id===state.game)+'">'
    +'<span class="flag">'+escHtml(g.code)+'</span>'
    +(g.soon ? '<span class="soonpad">🔒</span>' : '')
    +peek
    +'<img src="'+g.art+'" alt="" loading="lazy" decoding="async">'
    +'<b>'+escHtml(g.name)+'</b><small class="'+(g.soon?'':'on')+'">'+(g.soon?'COMING SOON':'● LIVE NOW')+'</small>'
    +'</button>';
}
if ($('#tiles')) $('#tiles').innerHTML = GAMES.map(function(g){ return tileHTML(g,false); }).join('');
if ($('#ddGrid')) $('#ddGrid').innerHTML = GAMES.map(function(g){ return tileHTML(g,true); }).join('');
if ($('#sheetGrid')) $('#sheetGrid').innerHTML = GAMES.map(function(g){ return tileHTML(g,true); }).join('');

/* ===== RENDER ===== */
/* Featured = boosted items first, then your admin/best-seller order with
   the newest items woven in every 4th slot (fresh stock stays near the top
   even before it has sales history). */
function weaveFeatured(all){
  all = all.slice().sort(function(a,b){ return a.dataset.idx - b.dataset.idx; });
  var boosted = all.filter(function(c){ return c.dataset.boost === '1'; });
  var sunk = all.filter(function(c){ return c.dataset.sink === '1' && c.dataset.boost !== '1'; });
  var list = all.filter(function(c){ return c.dataset.boost !== '1' && c.dataset.sink !== '1'; });
  if (list.length < 8) return boosted.concat(list).concat(sunk);
  var maxD = 0;
  list.forEach(function(c){ var d = +c.dataset.date || 0; if (d > maxD) maxD = d; });
  if (!maxD) return boosted.concat(list).concat(sunk);
  var fresh = list.filter(function(c){ return (+c.dataset.date || 0) >= maxD - 21*86400; })
                  .sort(function(a,b){ return (+b.dataset.date||0) - (+a.dataset.date||0); });
  if (fresh.length < 2 || fresh.length >= list.length) return boosted.concat(list).concat(sunk);
  var used = {}, out = [], fi = 0, bi = 0, pos = 0, pick;
  while (out.length < list.length){
    pick = null;
    if (pos % 4 === 3){
      while (fi < fresh.length && used[fresh[fi].dataset.handle]) fi++;
      if (fi < fresh.length) pick = fresh[fi++];
    }
    if (!pick){
      while (bi < list.length && used[list[bi].dataset.handle]) bi++;
      if (bi < list.length) pick = list[bi++];
    }
    if (!pick){
      while (fi < fresh.length && used[fresh[fi].dataset.handle]) fi++;
      if (fi < fresh.length) pick = fresh[fi++]; else break;
    }
    used[pick.dataset.handle] = true;
    out.push(pick); pos++;
  }
  return boosted.concat(out).concat(sunk);
}
function emptyHTML(title, sub){
  return '<div class="empty"><img src="'+(KP.emptyImg||'')+'" alt=""><b>'+title+'</b><span>'+sub+'</span></div>';
}
function render(unlock){
  if (!grid) return;
  var g = gameById(state.game);
  var tpl = TPL[state.game];
  var cards = tpl ? Array.prototype.slice.call(tpl.children) : [];
  var hasSubs = g && g.subs.length > 0;
  var list = cards.filter(function(c){
    if (hasSubs && state.sub && c.dataset.sub !== state.sub) return false;
    return true;
  });
  var stock = list.length;
  if (state.q){
    var qq = state.q.toLowerCase();
    list = list.filter(function(c){ return c.dataset.name.indexOf(qq) !== -1; });
  }
  if (state.sort === 'low') list.sort(function(a,b){ return a.dataset.price - b.dataset.price; });
  else if (state.sort === 'high') list.sort(function(a,b){ return b.dataset.price - a.dataset.price; });
  else list = weaveFeatured(list);

  /* banner (home only — collection pages render it server-side) */
  var bw = $('#bwrap');
  if (bw && g){
    bw.style.setProperty('--t', g.tint);
    if (g.banner){
      $('#bImg').src = g.banner; $('#bImg').alt = 'Shop ' + g.name;
      $('#bImg').hidden = false; $('#bFall').hidden = true;
    } else {
      $('#bImg').hidden = true; $('#bFall').hidden = false;
      $('#bfTitle').textContent = g.name;
      $('#bfSub').textContent = g.fall || '';
      $('#bfArt').src = g.art;
    }
    var lc = $('#liveCount');
    if (lc){
      if (g.soon){ lc.dataset.soon = '1'; delete lc.dataset.v; lc.textContent = 'Opens soon'; }
      else { lc.dataset.soon = '0'; paintViewers(true); }
    }
    var va = $('#viewAllBtn');
    if (va && g.url) va.href = g.url;
  }

  var st = $('#subtabs');
  if (st){
    st.innerHTML = (g && hasSubs) ? g.subs.map(function(s){
      return '<button class="subtab" data-subid="'+escHtml(s.id)+'" aria-selected="'+(s.id===state.sub)+'">'+escHtml(s.label)+'</button>';
    }).join('') : '';
  }

  document.querySelectorAll('#tiles .tile').forEach(function(t){
    t.setAttribute('aria-selected', t.dataset.game === state.game);
  });
  updateBdots();
  updateHotbar();
  if (unlock && bw){
    bw.classList.remove('is-unlock','is-swap-l','is-swap-r'); void bw.offsetWidth;
    if (swapDir){ bw.classList.add(swapDir > 0 ? 'is-swap-l' : 'is-swap-r'); swapDir = 0; }
    else bw.classList.add('is-unlock');
  }

  var cnt = $('#count');
  if (cnt) cnt.textContent = (g && g.soon && !stock) ? g.name + ' · opening soon' : list.length + ' items · updated today';

  state.shown = SHOW_STEP;
  RENDER_LIST = list;
  grid.innerHTML = '';
  if (list.length){
    list.slice(0, state.shown).forEach(function(c, n){
      var node = c.cloneNode(true);
      node.style.setProperty('--i', Math.min(n, 24));
      grid.appendChild(node);
    });
    updateSeeMore(g);
  } else {
    updateSeeMore(g);
    var subLabel = 'items';
    if (g && hasSubs){
      for (var k=0;k<g.subs.length;k++) if (g.subs[k].id === state.sub) subLabel = g.subs[k].label;
    }
    grid.innerHTML = emptyHTML(
      state.q ? 'No matches for “'+escHtml(state.q)+'”' : (g && g.soon) ? 'This shop opens soon' : 'No '+escHtml(subLabel)+' yet',
      state.q ? 'Try a different name, or clear the search.' : (g && g.soon) ? 'Join the Discord and you’ll be first to know.' : 'Restock lands here the moment it’s live.'
    );
  }
}

/* ===== BANNER DOTS + SWIPE ===== */
function buildBdots(){
  var wraps = [document.getElementById('bwrap'), document.getElementById('bwrapA')];
  wraps.forEach(function(bw){
    if (!bw || GAMES.length < 2 || bw.querySelector('.bdots')) return;
    var box = document.createElement('div');
    box.className = 'bdots';
    box.setAttribute('role','tablist');
    box.setAttribute('aria-label','Switch game');
    box.innerHTML = GAMES.map(function(g){
      return '<button class="bdot" data-bdot="'+escHtml(g.id)+'" aria-label="'+escHtml(g.name)+'"></button>';
    }).join('');
    bw.appendChild(box);
    box.addEventListener('click', function(e){
      var b = e.target.closest('.bdot'); if (!b) return;
      e.stopPropagation();
      var ci = 0, ni = 0;
      for (var k2=0;k2<GAMES.length;k2++){
        if (GAMES[k2].id === state.game) ci = k2;
        if (GAMES[k2].id === b.dataset.bdot) ni = k2;
      }
      selectGame(b.dataset.bdot, null, { scroll:false, dir: ni >= ci ? 1 : -1 });
    });
    /* swipe */
    var sx = null, sy = null;
    bw.addEventListener('touchstart', function(e){
      sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive:true });
    bw.addEventListener('touchend', function(e){
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      sx = null;
      if (Math.abs(dx) < 46 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      var idx2 = 0;
      for (var k=0;k<GAMES.length;k++) if (GAMES[k].id === state.game) idx2 = k;
      var nxt = (idx2 + (dx < 0 ? 1 : -1) + GAMES.length) % GAMES.length;
      selectGame(GAMES[nxt].id, null, { scroll:false, dir: dx < 0 ? 1 : -1 });
    }, { passive:true });
  });
}
function updateBdots(){
  document.querySelectorAll('.bdot').forEach(function(b){
    b.setAttribute('aria-current', String(b.dataset.bdot === state.game));
  });
}
buildBdots();
updateBdots();

/* ===== SHOW MORE (in-place expander) ===== */
function updateSeeMore(g){
  var sm = $('#seeMore'); if (!sm) return;
  var left = RENDER_LIST.length - state.shown;
  if (left > 0){
    sm.hidden = false;
    var subLab = '';
    if (g && g.subs && g.subs.length && state.sub){
      for (var si=0; si<g.subs.length; si++) if (g.subs[si].id === state.sub) subLab = g.subs[si].label.replace(/^[^ ]+ /, '');
    }
    $('#seeMoreLab').textContent = 'Show more ' + (subLab || 'items') + ' · ' + left + ' left';
  } else sm.hidden = true;
}
function showMore(){
  if (!grid) return;
  var start = state.shown;
  var next = RENDER_LIST.slice(start, start + SHOW_STEP);
  next.forEach(function(c, n){
    var node = c.cloneNode(true);
    node.classList.add('is-new');
    node.style.setProperty('--i', n);
    grid.appendChild(node);
  });
  state.shown = start + next.length;
  updateSeeMore(gameById(state.game));
}
document.addEventListener('click', function(e){
  if (e.target.closest('#seeMore')){ e.preventDefault(); showMore(); }
});

/* ===== GAME SELECT ===== */
function selectGame(id, sub, opts){
  var g = gameById(id); if (!g) return;
  opts = opts || {};
  if (!IS_HOME){
    window.location.href = g.url || KP.root || '/';
    return;
  }
  state.game = g.id;
  state.sub = sub || (g.subs.length ? g.subs[0].id : null);
  state.q = ''; if ($('#q')) $('#q').value = '';
  goHome();
  if (opts.dir) swapDir = opts.dir;
  render(true);
  closeAllDD(); closeSheet();
  if (opts.scroll === false) return; /* banner swipes/dots stay right where you are */
  var shop = document.getElementById('shop');
  if (shop) shop.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
}
document.addEventListener('click', function(e){
  var t = e.target.closest('[data-game]');
  if (t && !t.closest('.card')){
    e.preventDefault();
    selectGame(t.dataset.game, t.dataset.sub);
  }
});
document.addEventListener('click', function(e){
  var b = e.target.closest('[data-subid]');
  if (!b || !b.closest('#subtabs')) return;
  state.sub = b.dataset.subid; render(true);
});

/* ===== DROPDOWNS / SHEET ===== */
var DDs = [['gamesBtn','gamesDD'],['sortBtn','sortDD'],['tipBtn','tipDD']];
function closeAllDD(){
  DDs.forEach(function(p){
    var d = document.getElementById(p[1]), b = document.getElementById(p[0]);
    if (d) d.classList.remove('is-open');
    if (b) b.setAttribute('aria-expanded','false');
  });
  document.body.classList.remove('kp-ddpop');
}
DDs.forEach(function(p){
  var b = document.getElementById(p[0]), d = document.getElementById(p[1]);
  if (!b || !d) return;
  b.addEventListener('click', function(e){
    e.stopPropagation();
    var open = d.classList.contains('is-open');
    closeAllDD();
    if (!open){
      d.classList.add('is-open'); b.setAttribute('aria-expanded','true');
      document.body.classList.add('kp-ddpop'); /* lifts this shell above hotbar/mobar while a popup dropdown is up */
    }
  });
});
document.addEventListener('click', function(e){ if (!e.target.closest('.ddwrap')) closeAllDD(); });
/* on mobile the sort/tip dropdowns render as centered popups over a dim
   backdrop — a tap on the backdrop should only dismiss, never click through */
document.addEventListener('click', function(e){
  var openPop = document.querySelector('#sortDD.is-open, #tipDD.is-open');
  if (openPop && window.innerWidth <= 640 && !e.target.closest('.ddwrap')){
    e.preventDefault(); e.stopPropagation();
    closeAllDD();
  }
}, true);
document.addEventListener('keydown', function(e){
  if (e.key === 'Escape'){ closeAllDD(); closeSheet(); closeDrawer(); closePicker(); closeHowto(); closeCur(); if (typeof closeClaim === 'function') closeClaim(); }
  if (e.key === '/' && $('#q') && document.activeElement !== $('#q')){
    e.preventDefault(); $('#q').focus();
  }
});
var sortDD = $('#sortDD');
if (sortDD) sortDD.addEventListener('click', function(e){
  var o = e.target.closest('.opt'); if (!o) return;
  state.sort = o.dataset.sort;
  document.querySelectorAll('#sortDD .opt').forEach(function(x){ x.setAttribute('aria-selected', x === o); });
  $('#sortLabel').textContent = o.textContent.replace('✓','').trim();
  closeAllDD(); render(false);
});
var sheet = $('#sheet');
function closeSheet(){
  if (!sheet) return;
  sheet.classList.remove('is-open');
  var bg = $('#burger'); if (bg) bg.setAttribute('aria-expanded','false');
}
if ($('#burger')) $('#burger').addEventListener('click', function(){
  sheet.classList.add('is-open'); $('#burger').setAttribute('aria-expanded','true');
});
if ($('#sheetClose')) $('#sheetClose').addEventListener('click', closeSheet);
if (sheet){
  sheet.addEventListener('click', function(e){ if (e.target === sheet) closeSheet(); });
  sheet.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeSheet); });
}

/* ===== SEARCH ===== */
var qEl = $('#q');
if (qEl){
  qEl.addEventListener('input', function(e){ state.q = e.target.value.trim(); render(false); });
  qEl.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){ e.target.value=''; state.q=''; render(false); e.target.blur(); }
    if (e.key === 'Enter') e.preventDefault();
  });
}

/* ===== TOAST / FLYER / MOBAR ===== */
var toastT;
function toast(msg){
  var t = $('#toast'); if (!t) return;
  $('#toastMsg').textContent = msg;
  t.classList.add('is-up');
  clearTimeout(toastT);
  toastT = setTimeout(function(){ t.classList.remove('is-up'); }, 1900);
}
function flyToCart(img){
  if (RM || !img) return;
  var cartB = $('#cart'); if (!cartB) return;
  var r1 = img.getBoundingClientRect(), r2 = cartB.getBoundingClientRect();
  var c = img.cloneNode(); c.className = 'flyer';
  c.style.left = r1.left+'px'; c.style.top = r1.top+'px';
  c.style.width = r1.width+'px'; c.style.height = r1.height+'px'; c.style.padding = '0';
  document.body.appendChild(c);
  var dx = (r2.left + r2.width/2) - (r1.left + r1.width/2);
  var dy = (r2.top + r2.height/2) - (r1.top + r1.height/2);
  c.animate([
    { transform:'translate(0,0) scale(1) rotate(0deg)', opacity:1 },
    { transform:'translate('+(dx*.45)+'px,'+(dy-140)+'px) scale(.45) rotate(-14deg)', opacity:.95, offset:.55 },
    { transform:'translate('+dx+'px,'+dy+'px) scale(.1) rotate(10deg)', opacity:.25 }
  ], { duration:680, easing:'cubic-bezier(.32,.72,.35,1)' }).onfinish = function(){
    c.remove();
    cartB.classList.remove('is-bump'); void cartB.offsetWidth; cartB.classList.add('is-bump');
  };
}
function bumpCounts(cartData){
  var n = cartData.item_count;
  if ($('#cartN')) $('#cartN').textContent = n;
  if ($('#mobarN')) $('#mobarN').textContent = n + (n === 1 ? ' item' : ' items');
  if ($('#mobarT')) $('#mobarT').textContent = money(cartData.total_price);
  if (window.innerWidth < 640 && n > 0 && $('#mobar')) $('#mobar').classList.add('is-up');
}

/* ===== REAL CART ===== */
function fetchCart(){
  return fetch(KP.cartUrl ? KP.cartUrl.replace(/\/$/,'') + '.js' : '/cart.js', { headers:{ 'Accept':'application/json' } })
    .then(function(r){ return r.json(); });
}
function addToCart(variantId, qty){
  return fetch('/cart/add.js', {
    method:'POST',
    headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
    body: JSON.stringify({ items:[{ id: variantId, quantity: qty || 1 }] })
  }).then(function(r){
    if (!r.ok) return r.json().then(function(j){ throw new Error(j.description || j.message || 'Could not add to cart'); });
    return fetchCart();
  });
}
function changeLine(key, qty){
  return fetch('/cart/change.js', {
    method:'POST',
    headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  }).then(function(r){ return r.json(); });
}

/* drawer */
var drawerOpen = false;
function renderDrawer(c){
  var body = $('#cdrawBody'), foot = $('#cdrawFoot'), empty = $('#cdrawEmpty');
  if (!body) return;
  body.querySelectorAll('.cline').forEach(function(n){ n.remove(); });
  if (!c.items.length){
    if (empty) empty.hidden = false;
    if (foot) foot.hidden = true;
  } else {
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;
    c.items.forEach(function(it){
      var d = document.createElement('div');
      d.className = 'cline';
      d.innerHTML =
        '<span class="cline__shot">'+(it.image ? '<img src="'+it.image+(it.image.indexOf('?')>=0?'&':'?')+'width=128" alt="" width="64" height="64" loading="lazy">' : '')+'</span>'
        +'<span class="cline__mid"><b>'+escHtml(it.product_title)+'</b>'
        +(it.variant_title && it.variant_title !== 'Default Title' ? '<small>'+escHtml(it.variant_title)+'</small>' : '')
        +'<span class="lp">'+money(it.final_line_price)+'</span>'
        +'<button class="cline__rm" data-key="'+it.key+'">Remove</button></span>'
        +'<span class="cline__right"><span class="qty">'
        +'<button data-key="'+it.key+'" data-q="'+(it.quantity-1)+'" aria-label="Decrease quantity">−</button>'
        +'<b>'+it.quantity+'</b>'
        +'<button data-key="'+it.key+'" data-q="'+(it.quantity+1)+'" aria-label="Increase quantity">+</button>'
        +'</span></span>';
      body.appendChild(d);
    });
  }
  if ($('#cdrawN')) $('#cdrawN').textContent = c.item_count ? '· ' + c.item_count + (c.item_count===1?' item':' items') : '';
  if ($('#cdrawTotal')) $('#cdrawTotal').textContent = money(c.total_price);
  bumpCounts(c);
}
function openDrawer(){
  var d = $('#cdraw'), dim = $('#cdim');
  if (!d) return;
  dim.hidden = false;
  requestAnimationFrame(function(){ dim.classList.add('is-open'); d.classList.add('is-open'); });
  drawerOpen = true;
  fetchCart().then(renderDrawer).catch(function(){});
}
function closeDrawer(){
  var d = $('#cdraw'), dim = $('#cdim');
  if (!d || !drawerOpen) return;
  d.classList.remove('is-open'); dim.classList.remove('is-open');
  drawerOpen = false;
  setTimeout(function(){ dim.hidden = true; }, 280);
}
if ($('#cart')) $('#cart').addEventListener('click', openDrawer);
if ($('#cdrawClose')) $('#cdrawClose').addEventListener('click', closeDrawer);
if ($('#cdim')) $('#cdim').addEventListener('click', closeDrawer);
if ($('#cdrawCheckout')) $('#cdrawCheckout').addEventListener('click', function(){ window.location.href = '/checkout'; });
if ($('#cdrawBody')) $('#cdrawBody').addEventListener('click', function(e){
  var rm = e.target.closest('.cline__rm');
  var qb = e.target.closest('.qty button');
  if (rm){ changeLine(rm.dataset.key, 0).then(renderDrawer); }
  else if (qb){ changeLine(qb.dataset.key, Math.max(0, parseInt(qb.dataset.q,10))).then(renderDrawer); }
});

/* variant picker */
var pickerCtx = null;
function openPicker(btn){
  var v = $('#vpick'); if (!v) return;
  var variants;
  try { variants = JSON.parse(btn.getAttribute('data-variants')); } catch(err){ return; }
  pickerCtx = { img: btn.closest('.card') ? btn.closest('.card').querySelector('.card__shot img') : null };
  $('#vpickTitle').textContent = btn.getAttribute('data-ptitle') || 'Pick an option';
  $('#vpickImg').src = btn.getAttribute('data-pimg') || '';
  $('#vpickOpts').innerHTML = variants.map(function(vv){
    return '<button class="vopt" data-vid="'+parseInt(vv.id,10)+'"'+(vv.av ? '' : ' disabled')+'>'
      +'<span>'+escHtml(vv.t)+(vv.av ? '' : ' · sold out')+'</span><span class="p">'+money(vv.p)+'</span></button>';
  }).join('');
  v.hidden = false;
  requestAnimationFrame(function(){ v.classList.add('is-open'); });
}
function closePicker(){
  var v = $('#vpick'); if (!v || v.hidden) return;
  v.classList.remove('is-open');
  setTimeout(function(){ v.hidden = true; }, 220);
}
if ($('#vpickClose')) $('#vpickClose').addEventListener('click', closePicker);
if ($('#vpick')) $('#vpick').addEventListener('click', function(e){
  if (e.target === $('#vpick')) closePicker();
  var o = e.target.closest('.vopt');
  if (o && !o.disabled){
    var img = pickerCtx && pickerCtx.img;
    closePicker();
    addToCart(parseInt(o.dataset.vid,10), 1).then(function(c){
      flyToCart(img);
      renderDrawer(c);
      if (window.innerWidth >= 640) toast('Added to cart — nice pick ✨');
    }).catch(function(err){ toast('⚠️ ' + err.message); });
  }
});

/* add buttons (cards) */
function onAdd(e){
  var b = e.target.closest('.add');
  if (!b || b.disabled) return;
  e.preventDefault();
  if (b.hasAttribute('data-variants')){ openPicker(b); return; }
  var vid = parseInt(b.getAttribute('data-variant-id'),10);
  if (!vid) return;
  addToCart(vid, 1).then(function(c){
    flyToCart(b.closest('.card').querySelector('.card__shot img'));
    b.classList.add('is-done');
    b.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5 9 17.5 20 6.5"/></svg>';
    setTimeout(function(){
      b.classList.remove('is-done');
      b.innerHTML = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
    }, 1200);
    if (RM){ var cb = $('#cart'); if (cb){ cb.classList.remove('is-bump'); void cb.offsetWidth; cb.classList.add('is-bump'); } }
    renderDrawer(c);
    if (window.innerWidth >= 640) toast('Added to cart — nice pick ✨');
  }).catch(function(err){ toast('⚠️ ' + err.message); });
}
document.addEventListener('click', onAdd);

/* ===== SOCIAL FEEDS (home) ===== */
var TP = [
  ['N','Nelson','I’ve bought from a few different stores and KeyPets is 100% the safer option. They actually care about your order and won’t keep you waiting forever.'],
  ['C','Carson','They gave me an extra echo frog!!! W KeyPets.'],
  ['E','Ethan F.','Thought I was gonna get scammed the first time. Bought one 67 to test it out — it worked, so I kept buying. Definitely worth it for the price.']
];
var DC = [
  {i:'V',c:'#E85C5C',n:'VITO',sp:1,lines:['i had to wait for a couple minutes, but i got what i wanted for cheap and because i waited, i got more than i ordered, so 10000/10, i recomend alot','did another order and it got delievered in seconds, the customer suppuort is fabulous']},
  {i:'G',c:'#F5B62E',n:'GMRBill83',lines:['10/10 Amazing and quick service','20/10 Always on point and great service all around']},
  {i:'L',c:'#5CD97A',n:'LiamG',tag:'HIVE',lines:['Got my stuff… have NO IDEA what I’m doing so thank you!']},
  {i:'T',c:'#8C6BFF',n:'Thewizz',tag:'PUMP',lines:['Vouche I got my star fruits and super sprinkles and super cans','Vouche they just gave me another 3 star fruits']},
  {i:'J',c:'#63A8F0',n:'James trading on PvB',lines:['second time I bought from keypets.gg vouch 100 percent']},
  {i:'S',c:'#C8CDD6',n:'Skelly',sp:1,lines:['100/10 was so fast and legit make sure u buy']},
  {i:'I',c:'#FF8FB8',n:'Is.-THE()USA)(',lines:['Vouch got my dragon’s breath','And thanks for the extra sprinklers and stuff','So fast']},
  {i:'A',c:'#E88CC8',n:'adoree.arii',blur:1,lines:['I vouch! Got the things I ordered plus extra stuff.']},
  {i:'J',c:'#F0A722',n:'jesse',tag:'ZBTV',sp:1,lines:['1000/10 would buy again an amazing service!!!']},
  {i:'A',c:'#F5B62E',n:'aymelous',tag:'MSFS',lines:['w fast and ez tought it was a scam but it was legit']},
  {i:'R',c:'#E85C5C',n:'Ryker Pickell',sp:1,lines:['Wwww 10/10 it took like an hour but it’s late at night so that’s probably why, would recommend']},
  {i:'M',c:'#5CD97A',n:'Mera2007',sp:1,lines:['W for the cheapst price']},
  {i:'B',c:'#9AA5CE',n:'bimbolo2000',tag:'FBG',lines:['10/10 fantastic fast and reliable']},
  {i:'A',c:'#F0512C',n:'Aniii223',lines:['Got the seeds fast!!! Recomended!','Got the extra stuff too']},
  {i:'M',c:'#63D6E8',n:'Max',tag:'DH',lines:['Vouch rb ice serpent & hypno bloom seed']},
  {i:'M',c:'#B8C0FF',n:'midge',lines:['This is great and reliable 999999999/10']},
  {i:'T',c:'#FF9E5C',n:'Toocutebabygirl',sp:1,lines:['It is sooo real I got my seed','And it’s the best']},
  {i:'W',c:'#C77BF2',n:'weedlejuice',lines:['Got extra stuff for free w']}
];
if ($('#tpTrack')){
  var tpCard = function(x){ return '<article class="tpq"><span class="stars"><i>★</i><i>★</i><i>★</i><i>★</i><i>★</i></span><p>'+x[2]+'</p><div class="who"><span>'+x[1]+'</span><small>· VERIFIED ORDER</small></div></article>'; };
  var dcCard = function(r){ return '<article class="dmsg'+(r.blur?' blurred':'')+'"><span class="av" style="background:'+r.c+'">'+r.i+'</span><span class="body"><span class="u" style="color:'+r.c+'">'+r.n+(r.tag?'<i class="tag">'+r.tag+'</i>':'')+(r.sp?' 🌿':'')+'<span class="role">✓ VOUCH</span></span>'+r.lines.map(function(l){return '<p>'+l+'</p>';}).join('')+'</span></article>'; };
  var tpHTML = TP.map(tpCard).join('') + TP.map(tpCard).join('');
  var dcHTML = DC.map(dcCard).join('');
  $('#tpTrack').innerHTML = tpHTML + tpHTML;
  $('#dcTrack').innerHTML = dcHTML + dcHTML;
}

/* ===== HOTBAR ===== */
var hbPills = $('#hbPills');
if (hbPills){
  var HB = GAMES.map(function(g){
    return { id: g.id, c: g.tint, lab: g.soon ? g.name + ' · soon' : g.name };
  });
  HB.push({ id:'help', c:'#9AA5CE', lab:'Tutorial & FAQ' });
  hbPills.innerHTML = HB.map(function(h){
    return '<button class="hb" data-hb="'+escHtml(h.id)+'" style="--c:'+escHtml(h.c)+'" aria-label="'+escHtml(h.lab)+'"><span class="hb__lab">'+escHtml(h.lab)+'</span><span class="hb__dot"></span></button>';
  }).join('');
  var EYE_ON='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.5-6.5 10-6.5S22 12 22 12s-3.5 6.5-10 6.5S2 12 2 12z"/><circle cx="12" cy="12" r="2.6"/></svg>';
  var EYE_OFF='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.5-6.5 10-6.5c2 0 3.7.6 5.1 1.4M22 12s-3.5 6.5-10 6.5c-2 0-3.7-.6-5.1-1.4M4 20 20 4"/></svg>';
  $('#hbEye').innerHTML = EYE_ON;
  $('#hbEye').addEventListener('click', function(){
    var off = $('#hotbar').classList.toggle('is-off');
    $('#hbEye').innerHTML = off ? EYE_OFF : EYE_ON;
    $('#hbEye').setAttribute('aria-expanded', String(!off));
  });
  hbPills.addEventListener('click', function(e){
    var b = e.target.closest('.hb'); if (!b) return;
    if (b.dataset.hb === 'help'){
      if (IS_HOME){ goHome(); document.getElementById('faq').scrollIntoView({behavior: RM ? 'auto' : 'smooth'}); }
      else window.location.href = (KP.root || '/') + '#faq';
      return;
    }
    selectGame(b.dataset.hb);
  });
}
function updateHotbar(){
  document.querySelectorAll('.hb[data-hb]').forEach(function(b){
    b.setAttribute('aria-current', String(b.dataset.hb === state.game));
  });
}
/* pills glide apart while the page scrolls, settle back on stop */
(function(){
  var hb = document.getElementById('hotbar');
  if (!hb || RM) return;
  var settle, moving = false;
  addEventListener('scroll', function(){
    if (!moving){ moving = true; hb.classList.add('is-scrolling'); }
    clearTimeout(settle);
    settle = setTimeout(function(){ moving = false; hb.classList.remove('is-scrolling'); }, 150);
  }, { passive: true });
})();

/* ===== ROUTER (home views + legacy #/all links) ===== */
function goHome(){
  if (!IS_HOME) return;
  $('#viewHome').hidden = false;
  if ($('#viewSpin')) $('#viewSpin').hidden = true;
}
function route(){
  var h = location.hash;
  if (h.indexOf('#/all/') === 0){
    var g = gameById(h.split('/')[2]);
    window.location.replace(g && g.url ? g.url : (KP.root || '/'));
    return;
  }
  if (!IS_HOME) return;
  if (h === '#/spin'){
    $('#viewHome').hidden = true;
    if ($('#viewSpin')) $('#viewSpin').hidden = false;
    window.scrollTo({ top:0, behavior:'instant' });
  } else goHome();
}
window.addEventListener('hashchange', route);
document.querySelectorAll('[data-home]').forEach(function(a){
  a.addEventListener('click', function(){ if (IS_HOME) goHome(); });
});
route();

/* ===== REVEAL + ORDER COUNT-UP ===== */
function countUp(){
  var el = $('#odo'); if (!el || el.dataset.done) return;
  el.dataset.done = 1;
  var target = parseInt(String(KP.ordersStat || '1000').replace(/[^0-9]/g,''),10) || 1000;
  if (RM){ el.textContent = target.toLocaleString(); return; }
  var T = 1300, start = performance.now();
  (function tick(now){
    var p = Math.min(1,(now-start)/T), e2 = 1-Math.pow(1-p,3);
    el.textContent = Math.round(e2*target).toLocaleString();
    if (p<1) requestAnimationFrame(tick);
  })(start);
}
if ('IntersectionObserver' in window){
  var io = new IntersectionObserver(function(es){
    es.forEach(function(x){
      if (x.isIntersecting){
        x.target.classList.add('in');
        if (x.target.id === 'stats') countUp();
        io.unobserve(x.target);
      }
    });
  }, { rootMargin:'0px 0px -8% 0px' });
  document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });
} else {
  document.querySelectorAll('.rv').forEach(function(el){ el.classList.add('in'); });
  countUp();
}

/* ===== LIQUID GOLD DUST ===== */
(function(){
  var cv = document.getElementById('dust'); if (!cv) return;
  var cx = cv.getContext('2d');
  var W,H,DPR,ps=[],raf;
  var mkSprite = function(r, soft){
    var s = document.createElement('canvas'); var d = r*2+8; s.width = s.height = d;
    var g = s.getContext('2d');
    if (soft){
      var gr = g.createRadialGradient(d/2,d/2,0,d/2,d/2,r+3);
      gr.addColorStop(0,'rgba(255,208,80,.9)'); gr.addColorStop(.55,'rgba(255,201,60,.35)'); gr.addColorStop(1,'rgba(255,201,60,0)');
      g.fillStyle = gr; g.fillRect(0,0,d,d);
    } else { g.fillStyle = '#FFC93C'; g.beginPath(); g.arc(d/2,d/2,r,0,7); g.fill(); }
    return s;
  };
  var SPR = { dot: mkSprite(4,false), glow: mkSprite(9,true) };
  function size(){
    DPR = Math.min(devicePixelRatio||1,2);
    W = innerWidth; H = innerHeight;
    cv.width = W*DPR; cv.height = H*DPR; cv.style.width = W+'px'; cv.style.height = H+'px';
    cx.setTransform(DPR,0,0,DPR,0,0);
    var n = W<640 ? 70 : 230; /* lighter particle field on phones */
    ps = Array.from({length:n},function(_,i2){
      var soft = i2%3===0;
      var bright = i2%9===0;
      return { soft:soft, bright:bright, x:Math.random()*W, y:Math.random()*H,
        s: bright ? (1+Math.random()*1.3) : soft ? (.5+Math.random()*1.15) : (.28+Math.random()*.72),
        a: bright ? (.5+Math.random()*.4) : soft ? (.1+Math.random()*.3) : (.16+Math.random()*.5),
        vy: .16+Math.random()*.6,
        sw: Math.random()*Math.PI*2,
        amp: 10+Math.random()*26,
        tw: .5+Math.random()*2 };
    });
  }
  function draw(t){
    cx.clearRect(0,0,W,H);
    for (var k=0;k<ps.length;k++){
      var p = ps[k];
      var sp = (p.soft || p.bright) ? SPR.glow : SPR.dot;
      var tw = RM ? 1 : (p.bright ? (.65+.35*Math.sin(t/700*p.tw+p.sw)) : (.55+.45*Math.sin(t/1000*p.tw+p.sw)));
      cx.globalAlpha = p.a*tw;
      var w = sp.width*p.s;
      var x = p.x+(RM?0:Math.sin(t/1900+p.sw)*p.amp);
      cx.drawImage(sp,x-w/2,p.y-w/2,w,w);
      if (!RM){ p.y-=p.vy; if (p.y<-14){ p.y=H+14; p.x=Math.random()*W; } }
    }
    cx.globalAlpha = 1;
  }
  var lastT = 0;
  function loop(t){
    if (t - lastT >= 33){ lastT = t; draw(t); }
    if (!RM) raf = requestAnimationFrame(loop);
  }
  size(); draw(0); if (!RM) raf = requestAnimationFrame(loop);
  addEventListener('resize', function(){ size(); if (RM) draw(0); });
  document.addEventListener('visibilitychange', function(){
    if (RM) return;
    if (document.hidden) cancelAnimationFrame(raf); else raf = requestAnimationFrame(loop);
  });
})();

/* ===== GAMES ROTATOR (hero) ===== */
(function(){
  var box = document.getElementById('rota'); if (!box) return;
  var R = GAMES.map(function(g){ return { id:g.id, n:g.name, c:g.tint, soon:g.soon }; });
  R.push({ n:'Blox Fruits', c:'#4C9FF0', soon:1 });
  box.innerHTML = R.map(function(t){
    var inner = '<i style="--c:'+escHtml(t.c)+'"></i>'+escHtml(t.n)+(t.soon?' <span class="soon">SOON</span>':'');
    return t.id ? '<button class="tk" data-game="'+t.id+'">'+inner+'</button>' : '<span class="tk">'+inner+'</span>';
  }).join('');
  var items = Array.prototype.slice.call(box.children); var idx = 0;
  if (!items.length) return;
  items[0].classList.add('is-on');
  var timer = setInterval(step, 2050);
  function step(){
    var cur = items[idx]; idx = (idx+1)%items.length; var nxt = items[idx];
    cur.classList.remove('is-on'); cur.classList.add('is-out');
    setTimeout(function(){ cur.classList.remove('is-out'); },600);
    nxt.classList.add('is-on');
  }
  box.addEventListener('mouseenter', function(){ clearInterval(timer); });
  box.addEventListener('mouseleave', function(){ clearInterval(timer); timer = setInterval(step,2050); });
})();

/* ===== TYPEWRITER ===== */
(function(){
  var el = document.getElementById('typeTxt'); if (!el) return;
  var words = ['Secrets.','Star Fruit Seeds.','your favorite pet.','supplies for your content.','a gift for your friend.','OG Brainrots.','Gears.','New Seeds!','Dragons.'];
  if (RM){ el.textContent = words[0]; return; }
  var wi=0, ci=words[0].length, del=false;
  function tick(){
    var w = words[wi];
    el.textContent = w.slice(0,ci);
    var t = del?34:62;
    if (!del && ci===w.length){ t=1500; del=true; }
    else if (del && ci===0){ del=false; wi=(wi+1)%words.length; t=280; }
    else ci += del?-1:1;
    setTimeout(tick,t);
  }
  setTimeout(tick,900);
})();

/* ===== HOW-TO CLAIM POPUP ===== */
var howto = $('#howto');
function openHowto(){
  if (!howto) return;
  howto.hidden = false;
  requestAnimationFrame(function(){ howto.classList.add('is-open'); });
}
function closeHowto(){
  if (!howto || howto.hidden) return;
  howto.classList.remove('is-open');
  setTimeout(function(){ howto.hidden = true; }, 240);
}
document.addEventListener('click', function(e){
  var b = e.target.closest('[data-open-howto]');
  if (b){ e.preventDefault(); openHowto(); }
});
if ($('#howtoClose')) $('#howtoClose').addEventListener('click', closeHowto);

if (howto) howto.addEventListener('click', function(e){ if (e.target === howto) closeHowto(); });

/* ===== SHOPIFY INBOX OPENER ===== */
function openChat(){
  var tries = [
    function(){ if (window.ShopifyChat && typeof window.ShopifyChat.open === 'function'){ window.ShopifyChat.open(); return true; } },
    function(){ var el = document.querySelector('shopify-chat'); if (el){ var b = (el.shadowRoot || el).querySelector('button, iframe'); if (b){ b.click(); return true; } } },
    function(){ var f = document.getElementById('dummy-chat-button-iframe') || document.querySelector('iframe[title*="chat" i], iframe[id*="chat" i]'); if (f && f.parentElement){ f.parentElement.click(); return true; } },
    function(){ var b2 = document.querySelector('[id*="shopify-chat" i] button, [class*="shopify-chat" i] button'); if (b2){ b2.click(); return true; } }
  ];
  for (var i2=0;i2<tries.length;i2++){ try { if (tries[i2]()) return true; } catch(e){} }
  toast('💬 Tap the chat bubble in the bottom corner and paste your info');
  return false;
}

/* ===== CLAIM PORTAL WIZARD ===== */
var cport = $('#cport');
function openClaim(){
  if (!cport) return;
  closeHowto();
  cport.hidden = false;
  requestAnimationFrame(function(){ cport.classList.add('is-open'); });
}
function closeClaim(){
  if (!cport || cport.hidden) return;
  cport.classList.remove('is-open');
  setTimeout(function(){ cport.hidden = true; }, 240);
}
document.addEventListener('click', function(e){
  if (e.target.closest('[data-open-claim]')){ e.preventDefault(); openClaim(); }
});
if (cport){
  var cpStep = 0;
  var cpSteps = cport.querySelectorAll('.cport__step');
  var cpDots = cport.querySelectorAll('.cport__dots i');
  function cpShow(n){
    cpStep = Math.max(0, Math.min(cpSteps.length - 1, n));
    cpSteps.forEach(function(st){ st.classList.toggle('on', +st.dataset.step === cpStep); });
    cpDots.forEach(function(d, i3){ d.classList.toggle('on', i3 <= cpStep); });
    if (cpStep === cpSteps.length - 1){
      var v = function(id){ return ($(id) && $(id).value.trim()) || '—'; };
      $('#cpSum').innerHTML =
        '<div><b>🎮 Username:</b> ' + esc(v('#cpUser')) + '</div>' +
        '<div><b>🧾 Order #:</b> ' + esc(v('#cpOrder')) + '</div>' +
        '<div><b>📧 Contact:</b> ' + esc(v('#cpContact')) + '</div>' +
        '<div><b>🛍️ Items:</b> ' + esc(v('#cpItems')) + '</div>';
    }
    var inp = cpSteps[cpStep].querySelector('input, textarea');
    if (inp) setTimeout(function(){ inp.focus(); }, 200);
  }
  function esc(t){ var d = document.createElement('span'); d.textContent = t; return d.innerHTML; }
  cport.addEventListener('click', function(e){
    if (e.target === cport){ closeClaim(); return; }
    if (e.target.closest('[data-cp-next]')) cpShow(cpStep + 1);
    else if (e.target.closest('[data-cp-back]')) cpShow(cpStep - 1);
  });
  cport.addEventListener('keydown', function(e){
    if (e.key === 'Enter' && e.target.tagName === 'INPUT'){ e.preventDefault(); cpShow(cpStep + 1); }
  });
  if ($('#cportClose')) $('#cportClose').addEventListener('click', closeClaim);
  if ($('#cpSend')) $('#cpSend').addEventListener('click', function(){
    var v = function(id){ return ($(id) && $(id).value.trim()) || '-'; };
    var msg = 'Hi! I would like to claim my order 🐰\n' +
      'Roblox username: ' + v('#cpUser') + '\n' +
      'Order number: ' + v('#cpOrder') + '\n' +
      'Email/phone: ' + v('#cpContact') + '\n' +
      'Items: ' + v('#cpItems');
    var done = function(){
      closeClaim();
      setTimeout(openChat, 300);
      toast('📋 Copied! Paste it in the chat');
    };
    if (navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(msg).then(done, done);
    } else done();
  });
}

/* ===== MONEY MASCOT EASTER EGG ===== */
(function(){
  var mg = $('#moneyGuy'), bub = $('#flankBub');
  if (!mg || !bub) return;
  var code = (KP.promoCode || '').trim();
  if (!code){ mg.style.cursor = 'default'; return; }
  var line = (KP.promoLine || '').trim();
  bub.innerHTML = line
    ? line.replace(/\{code\}/g, '<b>' + code + '</b>')
    : 'Ptsss… hey you. Use code <b>' + code + '</b> for a lil’ discount on your order. Tell no one. 🤫';
  var t;
  mg.addEventListener('click', function(){
    mg.classList.remove('is-hyped'); void mg.offsetWidth; mg.classList.add('is-hyped');
    bub.hidden = false;
    requestAnimationFrame(function(){ bub.classList.add('is-on'); });
    clearTimeout(t);
    t = setTimeout(function(){
      bub.classList.remove('is-on');
      setTimeout(function(){ bub.hidden = true; }, 260);
    }, 4000);
  });
})();

/* ===== CART PAGE steppers ===== */
document.querySelectorAll('[data-kp-cartpage] .cq').forEach(function(b){
  b.addEventListener('click', function(){
    var inp = b.parentElement.querySelector('input[name="updates[]"]');
    var v = Math.max(0, parseInt(inp.value||'0',10) + parseInt(b.dataset.d,10));
    inp.value = v;
    var form = b.closest('form');
    if (form) form.submit();
  });
});

/* ===== PRODUCT PAGE ===== */
(function(){
  var root = document.querySelector('[data-kp-product]'); if (!root) return;
  var dataEl = document.getElementById('ppData'); if (!dataEl) return;
  var product; try { product = JSON.parse(dataEl.textContent); } catch(e){ return; }
  var sel = document.getElementById('ppVariantSelect');
  var qtyEl = document.getElementById('ppQty');
  var qtyInput = document.getElementById('ppQtyInput');
  var qty = 1;
  function current(){
    var id = parseInt(sel.value,10);
    for (var k=0;k<product.variants.length;k++) if (product.variants[k].id===id) return product.variants[k];
    return product.variants[0];
  }
  function chosenValues(){
    var vals = [];
    root.querySelectorAll('.vswatch[aria-pressed="true"]').forEach(function(b){ vals[parseInt(b.dataset.opt,10)] = b.dataset.val; });
    return vals;
  }
  function syncFromSwatches(){
    var vals = chosenValues();
    var match = null;
    for (var k=0;k<product.variants.length;k++){
      var v = product.variants[k], ok = true;
      for (var o=0;o<vals.length;o++){
        if (vals[o] && v.options[o] !== vals[o]) ok = false;
      }
      if (ok){ match = v; break; }
    }
    if (match){
      sel.value = match.id;
      var priceEl = document.getElementById('ppPrice'), wasEl = document.getElementById('ppWas');
      priceEl.textContent = money(match.price);
      priceEl.setAttribute('data-cents', match.price);
      if (match.compare_at_price && match.compare_at_price > match.price){
        wasEl.hidden = false; wasEl.textContent = money(match.compare_at_price);
        wasEl.setAttribute('data-cents', match.compare_at_price);
      } else { wasEl.hidden = true; wasEl.removeAttribute('data-cents'); }
      var addB = document.getElementById('ppAdd');
      if (addB){ addB.disabled = !match.available; addB.textContent = match.available ? 'Add to cart' : 'Sold out'; }
    }
  }
  root.querySelectorAll('.vswatch').forEach(function(b){
    b.addEventListener('click', function(){
      root.querySelectorAll('.vswatch[data-opt="'+b.dataset.opt+'"]').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
      b.setAttribute('aria-pressed','true');
      syncFromSwatches();
    });
  });
  var minus = document.getElementById('ppMinus'), plus = document.getElementById('ppPlus');
  if (minus) minus.addEventListener('click', function(){ qty = Math.max(1, qty-1); qtyEl.textContent = qty; qtyInput.value = qty; });
  if (plus) plus.addEventListener('click', function(){ qty = Math.min(99, qty+1); qtyEl.textContent = qty; qtyInput.value = qty; });
  var form = document.getElementById('ppForm');
  if (form) form.addEventListener('submit', function(e){
    if (e.submitter && e.submitter.name === 'return_to') return; /* Buy it now → native */
    e.preventDefault();
    var v = current();
    addToCart(v.id, qty).then(function(c){
      renderDrawer(c);
      openDrawer();
    }).catch(function(err){ toast('⚠️ ' + err.message); });
  });
})();

/* ===== CURRENCY SWITCHER =====
   Lets visitors see every price in their own currency. Display-only:
   checkout still charges the store currency. Live rates refresh from
   open.er-api.com (cached 12h); baked-in rates cover offline/first paint. */
var CUR_LIST = [
  ['USD','$','🇺🇸','US Dollar'], ['EUR','€','🇪🇺','Euro'], ['GBP','£','🇬🇧','British Pound'],
  ['CAD','CA$','🇨🇦','Canadian Dollar'], ['AUD','A$','🇦🇺','Australian Dollar'], ['NZD','NZ$','🇳🇿','New Zealand Dollar'],
  ['BRL','R$','🇧🇷','Brazilian Real'], ['MXN','MX$','🇲🇽','Mexican Peso'], ['COP','COL$','🇨🇴','Colombian Peso'],
  ['CLP','CLP$','🇨🇱','Chilean Peso'], ['ARS','ARS$','🇦🇷','Argentine Peso'], ['PEN','S/','🇵🇪','Peruvian Sol'],
  ['JPY','¥','🇯🇵','Japanese Yen'], ['KRW','₩','🇰🇷','South Korean Won'], ['CNY','CN¥','🇨🇳','Chinese Yuan'],
  ['HKD','HK$','🇭🇰','Hong Kong Dollar'], ['TWD','NT$','🇹🇼','New Taiwan Dollar'], ['SGD','S$','🇸🇬','Singapore Dollar'],
  ['MYR','RM','🇲🇾','Malaysian Ringgit'], ['IDR','Rp','🇮🇩','Indonesian Rupiah'], ['PHP','₱','🇵🇭','Philippine Peso'],
  ['THB','฿','🇹🇭','Thai Baht'], ['VND','₫','🇻🇳','Vietnamese Dong'], ['INR','₹','🇮🇳','Indian Rupee'],
  ['SEK','kr','🇸🇪','Swedish Krona'], ['NOK','kr','🇳🇴','Norwegian Krone'], ['DKK','kr','🇩🇰','Danish Krone'],
  ['CHF','CHF','🇨🇭','Swiss Franc'], ['PLN','zł','🇵🇱','Polish Złoty'], ['CZK','Kč','🇨🇿','Czech Koruna'],
  ['HUF','Ft','🇭🇺','Hungarian Forint'], ['RON','lei','🇷🇴','Romanian Leu'], ['TRY','₺','🇹🇷','Turkish Lira'],
  ['ILS','₪','🇮🇱','Israeli Shekel'], ['AED','AED','🇦🇪','UAE Dirham'], ['SAR','SAR','🇸🇦','Saudi Riyal'],
  ['ZAR','R','🇿🇦','South African Rand'], ['NGN','₦','🇳🇬','Nigerian Naira'], ['EGP','E£','🇪🇬','Egyptian Pound']
];
var CUR_RATES = { USD:1, EUR:0.89, GBP:0.75, CAD:1.38, AUD:1.55, NZD:1.68, BRL:5.65, MXN:19.4, COP:4200, CLP:940, ARS:1180, PEN:3.66, JPY:145, KRW:1390, CNY:7.21, HKD:7.82, TWD:30.2, SGD:1.29, MYR:4.3, IDR:16300, PHP:55.7, THB:32.9, VND:26000, INR:85.5, SEK:9.7, NOK:10.4, DKK:6.64, CHF:0.83, PLN:3.8, CZK:22.1, HUF:359, RON:4.43, TRY:38.8, ILS:3.6, AED:3.67, SAR:3.75, ZAR:18.1, NGN:1590, EGP:49.7 };
var CUR_ZERO = { JPY:1, KRW:1, VND:1, IDR:1, CLP:1, COP:1, HUF:1 };
var BASE_CUR = (KP.currency || 'USD').toUpperCase();
var CAN_CONVERT = !!CUR_RATES[BASE_CUR];
var curNow = BASE_CUR;
function lsGet(k){ try { return localStorage.getItem(k); } catch(e){ return null; } }
function lsSet(k, v){ try { localStorage.setItem(k, v); } catch(e){} }
if (CAN_CONVERT){
  var savedCur = lsGet('kp_currency');
  if (savedCur && CUR_RATES[savedCur]) curNow = savedCur;
}
function curSym(code){
  for (var ci=0; ci<CUR_LIST.length; ci++) if (CUR_LIST[ci][0] === code) return CUR_LIST[ci][1];
  return code + ' ';
}
function curFmt(cents){
  var rb = CUR_RATES[BASE_CUR] || 1, rt = CUR_RATES[curNow] || 1;
  var v = (cents / 100) * (rt / rb);
  var dec = CUR_ZERO[curNow] ? 0 : 2;
  return curSym(curNow) + v.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
}
function curLabels(){
  var l1 = $('#curBtnCode'); if (l1) l1.textContent = curNow;
  var l2 = $('#curSheetCode'); if (l2) l2.textContent = curNow;
  document.querySelectorAll('#curOpts .copt').forEach(function(b){
    b.setAttribute('aria-pressed', String(b.dataset.cur === curNow));
  });
}
function repriceAll(){
  var roots = [document];
  for (var tk in TPL){ if (TPL[tk] && TPL[tk].querySelectorAll) roots.push(TPL[tk]); }
  roots.forEach(function(root){
    var els = root.querySelectorAll('[data-cents]');
    for (var pi=0; pi<els.length; pi++){
      var cents = parseInt(els[pi].getAttribute('data-cents'), 10);
      if (!isNaN(cents)) els[pi].textContent = money(cents);
    }
  });
  curLabels();
}
if (CAN_CONVERT && window.fetch){
  var ratesFresh = false;
  try {
    var cachedR = JSON.parse(lsGet('kp_rates') || 'null');
    if (cachedR && cachedR.t && (Date.now() - cachedR.t) < 43200000 && cachedR.r){
      for (var ck in cachedR.r){ if (Object.prototype.hasOwnProperty.call(CUR_RATES, ck)) CUR_RATES[ck] = cachedR.r[ck]; }
      ratesFresh = true;
    }
  } catch(e){}
  if (!ratesFresh){
    fetch('https://open.er-api.com/v6/latest/USD')
      .then(function(r){ return r.json(); })
      .then(function(j){
        if (!j || j.result !== 'success' || !j.rates) return;
        var keep = {};
        for (var k in CUR_RATES){ if (typeof j.rates[k] === 'number'){ CUR_RATES[k] = j.rates[k]; keep[k] = j.rates[k]; } }
        lsSet('kp_rates', JSON.stringify({ t: Date.now(), r: keep }));
        if (curNow !== BASE_CUR) repriceAll();
      })
      .catch(function(){});
  }
}
function buildCurOpts(){
  var box = $('#curOpts');
  if (!box || box.childElementCount) return;
  box.innerHTML = CUR_LIST.map(function(c){
    return '<button class="copt" data-cur="'+c[0]+'" aria-pressed="'+String(c[0] === curNow)+'">'
      + '<span class="copt__flag" aria-hidden="true">'+c[2]+'</span>'
      + '<span class="copt__code">'+c[0]+'</span>'
      + '<span class="copt__name">'+escHtml(c[3])+'</span>'
      + '<span class="copt__sym">'+escHtml(c[1])+'</span></button>';
  }).join('');
}
function openCur(){
  var m = $('#curModal'); if (!m) return;
  buildCurOpts();
  closeAllDD(); closeSheet();
  m.hidden = false;
  requestAnimationFrame(function(){
    m.classList.add('is-open');
    var on = m.querySelector('.copt[aria-pressed="true"]'), box = $('#curOpts');
    if (on && box && on.offsetTop > 260) box.scrollTop = on.offsetTop - 130;
  });
}
function closeCur(){
  var m = $('#curModal'); if (!m || m.hidden) return;
  m.classList.remove('is-open');
  setTimeout(function(){ m.hidden = true; }, 220);
}
document.addEventListener('click', function(e){
  var ob = e.target.closest('[data-open-currency]');
  if (ob){ e.preventDefault(); openCur(); return; }
  var co = e.target.closest('#curOpts .copt');
  if (co){
    var pick = co.dataset.cur;
    if (pick && pick !== curNow){
      curNow = pick;
      lsSet('kp_currency', curNow);
      repriceAll();
      toast(pick === BASE_CUR ? '💱 Back to ' + BASE_CUR : '💱 Prices shown in ' + pick + ' (est.)');
    }
    closeCur();
  }
});
if ($('#curClose')) $('#curClose').addEventListener('click', closeCur);
if ($('#curModal')) $('#curModal').addEventListener('click', function(e){ if (e.target === $('#curModal')) closeCur(); });
if (!CAN_CONVERT){
  /* store currency not in the table → hide the switcher rather than mis-convert */
  document.querySelectorAll('[data-open-currency]').forEach(function(b){ b.style.display = 'none'; });
} else if (curNow !== BASE_CUR){
  repriceAll(); /* returning visitor with a saved currency */
} else {
  curLabels();
}

/* ===== COLLECTION PAGE bootstrapping ===== */
if (colMain){
  var g0 = gameById(state.game);
  var params = new URLSearchParams(location.search);
  var wantSub = params.get('sub');
  if (g0 && g0.subs.length){
    state.sub = (wantSub && g0.subs.some(function(s){ return s.id === wantSub; })) ? wantSub : g0.subs[0].id;
    render(false);
  }
  /* non-game collections keep the server-rendered grid as-is until a control is used */
  else if (grid && TPL[state.game]) render(false);
}

/* ===== HOME bootstrapping ===== */
if (IS_HOME && GAMES.length){
  var gh = gameById(state.game);
  state.sub = gh && gh.subs.length ? gh.subs[0].id : null;
  render(false);
}

/* initial cart count sync */
if (typeof KP.cartCount === 'number' && $('#cartN')) $('#cartN').textContent = KP.cartCount;
if ($('#mobarT') && !$('#mobarT').textContent) $('#mobarT').textContent = money(0);
})();
